export class SummaryBox {
  constructor(public title: string, public text: string, public hint?: string) {}
}
